import IFellowshipGroup from '../interfaces/IFellowshipGroup';

const UnregisterGroup: IFellowshipGroup = {
    id: 'unregisteredGroup',
    name: 'Unregistered Group',
    description: '',
    creatorId: '',
    memberIds: [],
    memberInfo: [],
    joinCode: '',
    syncCode: '',
    createdDate: Date.now(),
    modifiedDate: Date.now(),
}

  export default UnregisterGroup;